import GlobalSearch from '@app/components/GlobalSearch'
import * as React from 'react'
import DocumentTitle from 'react-document-title'
import { Col, Container, Row } from 'reactstrap'

export default class SearchPage extends React.PureComponent<{}> {
  public render() {
    return (
      <DocumentTitle title='Site Search'>
        <Container className='mt-3'>
          <Row>
            <Col>
              <h3>Site Search</h3>
            </Col>
          </Row>
          <Row>
            <Col>
              <GlobalSearch id='search-page' inlineResults />
            </Col>
          </Row>
        </Container>
      </DocumentTitle>
    )
  }
}
